import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-skeleton-loader',
	templateUrl: './skeleton-loader.component.html',
	styleUrls: ['./skeleton-loader.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonLoaderComponent implements OnInit {
	@Input() SHOW_PANEL: boolean = false;
	@Input() DEFAULT_CARDS_SIZE: number = 3;
	@Input() DEFAULT_ROWS_SIZE: number = 3;
	@Input() DEFAULT_COLUMN_SIZE: number = 4;
	@Input() SHOW_CHIPS: boolean = false;
	@Input() DEFAULT_CHIPS_SIZE: number = 5;
	@Input() SHOW_CURRENT_RATES: boolean = false;
	@Input() SHOW_RECENT_TRANSACTIONS: boolean = false;
	@Input() SHOW_DASHBOARD_HOT_LANES: boolean = false;
	@Input() SHOW_SINGLE_LOADER: boolean = false;
	@Input() cssClasses: string = '';

	panelSkeletonList = [];
	panelRowsList = [];
	panelColumnsList = [];
	chipsList = [];

	constructor() {}

	get cssClassesList(): string {
		return this.cssClasses;
	}

	ngOnInit(): void {
		this.panelSkeletonList = this.buildList(this.DEFAULT_CARDS_SIZE);
		this.panelRowsList = this.buildList(this.DEFAULT_ROWS_SIZE);
		this.panelColumnsList = this.buildList(this.DEFAULT_COLUMN_SIZE);
		this.chipsList = this.buildList(this.DEFAULT_CHIPS_SIZE);
	}

	buildList(count): Array<number> {
		const indexes = [];
		for (let skeletonCounter = 0; skeletonCounter < count; skeletonCounter++) {
			indexes.push(skeletonCounter);
		}
		return indexes;
	}
}
